module.exports = "/_next/static/images/2e408d1035ebb8eee323003866486863-wow@0.5x.png.webp";